import { render, staticRenderFns } from "./RecipeListView.vue?vue&type=template&id=6c7a4e70&scoped=true"
import script from "./RecipeListView.vue?vue&type=script&lang=js"
export * from "./RecipeListView.vue?vue&type=script&lang=js"
import style0 from "./RecipeListView.vue?vue&type=style&index=0&id=6c7a4e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a4e70",
  null
  
)

export default component.exports